import { buildColorByThemeForColor } from "@/commons/constants/ThemeColor";
import { ETheme } from "..";

export const IconNoDataMedium = (props: { theme?: ETheme }) => {
  const theme = props.theme || ETheme.Light;
  return (
    <svg
      width="200"
      height="160"
      viewBox="0 0 200 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M108.8 51.2002C111.893 51.2003 114.4 53.7073 114.4 56.7998C114.4 59.8925 111.893 62.4003 108.8 62.4004H160C163.093 62.4006 165.6 64.9074 165.6 68C165.6 71.0927 163.093 73.6004 160 73.6006H177.6C180.693 73.6006 183.2 76.1074 183.2 79.2002C183.2 82.293 180.693 84.7998 177.6 84.7998H162.4C159.307 84.7999 156.8 87.3077 156.8 90.4004C156.8 93.493 159.307 95.9999 162.4 96H167.2C170.292 96 172.8 98.5078 172.8 101.601C172.8 104.693 170.292 107.2 167.2 107.2H125.6C125.188 107.2 124.786 107.156 124.4 107.071C124.013 107.156 123.612 107.2 123.2 107.2H50.3999C47.3073 107.2 44.8005 104.693 44.8003 101.601C44.8003 98.5079 47.3072 96.0001 50.3999 96H19.1997C16.1072 95.9998 13.6002 93.493 13.6001 90.4004C13.6001 87.3077 16.1071 84.8 19.1997 84.7998H51.1997C54.2925 84.7998 56.8003 82.293 56.8003 79.2002C56.8003 76.1074 54.2925 73.6006 51.1997 73.6006H31.1997C28.1071 73.6004 25.6001 71.0927 25.6001 68C25.6002 64.9074 28.1072 62.4006 31.1997 62.4004H63.1997C60.1071 62.4002 57.6001 59.8925 57.6001 56.7998C57.6003 53.7073 60.1072 51.2004 63.1997 51.2002H108.8ZM180.8 96C183.893 96.0002 186.4 98.5071 186.4 101.6C186.4 104.692 183.893 107.2 180.8 107.2C177.708 107.2 175.2 104.692 175.2 101.6C175.2 98.507 177.708 96 180.8 96Z"
        fill={buildColorByThemeForColor(theme, "#F3F7FF", "#101010")}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M90.495 89.8452C90.4325 90.2878 90.4002 90.7401 90.4002 91.1999C90.4002 96.5018 94.6983 100.8 100 100.8C105.302 100.8 109.6 96.5018 109.6 91.1999C109.6 90.7401 109.568 90.2878 109.505 89.8452H132.8V111.2C132.8 112.525 131.726 113.6 130.4 113.6H69.6002C68.2747 113.6 67.2002 112.525 67.2002 111.2V89.8452H90.495Z"
        fill={buildColorByThemeForColor(theme, "white", "black")}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M110.4 89.5998C110.4 95.3436 105.744 99.9998 100 99.9998C94.2564 99.9998 89.6002 95.3436 89.6002 89.5998C89.6002 89.4137 89.6051 89.2288 89.6147 89.0451H67.2002L74.8485 66.4309C75.1783 65.456 76.0929 64.7998 77.122 64.7998H122.878C123.908 64.7998 124.822 65.456 125.152 66.4309L132.8 89.0451H110.386C110.395 89.2288 110.4 89.4137 110.4 89.5998Z"
        fill={buildColorByThemeForColor(theme, "white", "black")}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M108.878 90.3636C108.878 94.802 104.903 99.2 99.9999 99.2C95.0967 99.2 91.1219 94.802 91.1219 90.3636C91.1219 90.2198 91.126 89.2769 91.1343 89.135H74.3999L80.929 73.2604C81.2105 72.507 81.9912 72 82.8698 72H117.13C118.009 72 118.789 72.507 119.071 73.2604L125.6 89.135H108.866C108.874 89.2769 108.878 90.2198 108.878 90.3636Z"
        fill={buildColorByThemeForColor(theme, "#E8F0FE", "#171717")}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M68.2002 89.2096V110.4C68.2002 111.173 68.827 111.8 69.6002 111.8H130.4C131.173 111.8 131.8 111.173 131.8 110.4V89.2096L124.205 66.7513C124.012 66.1826 123.479 65.7998 122.878 65.7998H77.122C76.5217 65.7998 75.9882 66.1826 75.7958 66.7513L68.2002 89.2096Z"
        stroke={buildColorByThemeForColor(theme, "#153359", "#3E6699")}
        stroke-width="2"
      />
      <path
        d="M78.4 88.7998C81.5493 88.7998 84.9479 88.7998 88.5959 88.7998C90.097 88.7998 90.097 89.8547 90.097 90.3998C90.097 95.7017 94.4939 99.9998 99.9178 99.9998C105.342 99.9998 109.739 95.7017 109.739 90.3998C109.739 89.8547 109.739 88.7998 111.24 88.7998H131.2M72.459 88.7998H74.4H72.459Z"
        stroke={buildColorByThemeForColor(theme, "#153359", "#3E6699")}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M120.08 46.6424L111.2 56.6049M99.2796 43.2002V56.6049V43.2002ZM78.3999 46.6424L87.2796 56.6049L78.3999 46.6424Z"
        stroke={buildColorByThemeForColor(theme, "#92B5D1", "#617B91")}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IconNoDataLarge = (props: { theme?: ETheme }) => {
  const theme = props.theme || ETheme.Light;
  return (
    <svg
      width="250"
      height="200"
      viewBox="0 0 250 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M136 64C139.866 64 143 67.134 143 71C143 74.866 139.866 78 136 78H200C203.866 78 207 81.134 207 85C207 88.866 203.866 92 200 92H222C225.866 92 229 95.134 229 99C229 102.866 225.866 106 222 106H203C199.134 106 196 109.134 196 113C196 116.866 199.134 120 203 120H209C212.866 120 216 123.134 216 127C216 130.866 212.866 134 209 134H157C156.485 134 155.983 133.944 155.5 133.839C155.017 133.944 154.515 134 154 134H63C59.134 134 56 130.866 56 127C56 123.134 59.134 120 63 120H24C20.134 120 17 116.866 17 113C17 109.134 20.134 106 24 106H64C67.866 106 71 102.866 71 99C71 95.134 67.866 92 64 92H39C35.134 92 32 88.866 32 85C32 81.134 35.134 78 39 78H79C75.134 78 72 74.866 72 71C72 67.134 75.134 64 79 64H136ZM226 120C229.866 120 233 123.134 233 127C233 130.866 229.866 134 226 134C222.134 134 219 130.866 219 127C219 123.134 222.134 120 226 120Z"
        fill={buildColorByThemeForColor(theme, "#F3F7FF", "#101010")}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M113.119 112.307C113.04 112.86 113 113.425 113 114C113 120.627 118.373 126 125 126C131.627 126 137 120.627 137 114C137 113.425 136.96 112.86 136.881 112.307H166V139C166 140.657 164.657 142 163 142H87C85.3431 142 84 140.657 84 139V112.307H113.119Z"
        fill={buildColorByThemeForColor(theme, "white", "black")}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M138 112C138 119.18 132.18 125 125 125C117.82 125 112 119.18 112 112C112 111.767 112.006 111.536 112.018 111.307H84L93.5604 83.0389C93.9726 81.8202 95.1159 81 96.4023 81H153.598C154.884 81 156.027 81.8202 156.44 83.0389L166 111.307H137.982C137.994 111.536 138 111.767 138 112Z"
        fill={buildColorByThemeForColor(theme, "white", "black")}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M136.098 112.955C136.098 118.502 131.129 124 125 124C118.871 124 113.902 118.502 113.902 112.955C113.902 112.775 113.908 111.596 113.918 111.419H93L101.161 91.5755C101.513 90.6338 102.489 90 103.587 90H146.413C147.511 90 148.487 90.6338 148.839 91.5755L157 111.419H136.082C136.092 111.596 136.098 112.775 136.098 112.955Z"
        fill={buildColorByThemeForColor(theme, "#E8F0FE", "#171717")}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M85.25 111.512V138C85.25 138.966 86.0335 139.75 87 139.75H163C163.966 139.75 164.75 138.966 164.75 138V111.512L155.255 83.4393C155.015 82.7285 154.348 82.25 153.598 82.25H96.4023C95.6519 82.25 94.985 82.7285 94.7446 83.4393L85.25 111.512Z"
        stroke={buildColorByThemeForColor(theme, "#153359", "#3E6699")}
        stroke-width="2.5"
      />
      <path
        d="M98 111C101.937 111 106.185 111 110.745 111C112.621 111 112.621 112.319 112.621 113C112.621 119.627 118.117 125 124.897 125C131.677 125 137.173 119.627 137.173 113C137.173 112.319 137.173 111 139.05 111H164M90.5737 111H93H90.5737Z"
        stroke={buildColorByThemeForColor(theme, "#153359", "#3E6699")}
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M150.1 58.3027L139 70.7559M124.1 54V70.7559V54ZM98 58.3027L109.1 70.7559L98 58.3027Z"
        stroke={buildColorByThemeForColor(theme, "#92B5D1", "#617B91")}
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
